// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html


import firebase from 'firebase/app'

// Initialize Firebase
const firebaseConfig = {
    apiKey: "AIzaSyDKpq-ppqSkVPBkdEzardrJ5cdytjK97Qw",
    authDomain: "redant-food.firebaseapp.com",
    databaseURL: "https://redant-food.firebaseio.com",
    projectId: "redant-food",
    storageBucket: "redant-food.appspot.com",
    messagingSenderId: "36295005702",
    appId: "1:36295005702:web:18d16123f3e6de2be2d587",
    measurementId: "G-LE0RS4EPXN"
  };

firebase.initializeApp(firebaseConfig);
